<template>
    <div>
        <b-modal
            ref="configSincronizacaoModal"
            title="Configuração de Sincronização"
            size="md"
            id="modal-config-sincronizacao"
        >
            <el-form ref="formConfigSincronizacao" :model="configModal" size="small" :rules="rules.configSincronizacao" class="form-format">
                <el-card shadow="always" class="card">
                    <b-form-row>
                        <div class="col-lg-4 col-md-4">
                            <img class="img-aviso-config" :src="require(`@/assets/aviso.svg`)" width="150px"/>
                        </div>
                        <div class="col-lg-8 col-md-8 ">
                            <p>
                                Configure sua sincronização com uma <b>data limite de competência</b>, suas sincronizações só obterão dados a partir da respectiva data selecionada.
                            </p>
                        </div>
                    </b-form-row>
                </el-card>
                <br>

                <el-form-item label="Sincronizar limite de competência a partir de" prop="dataLimite" required>
                    <el-date-picker
                        required
                        v-model="configModal.dataLimite"
                        type="month"
                        format="MM/yyyy"
                        size="small"
                        placeholder="Escolha o mês"
                         class="w-100"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="Status" prop="ativo">
                    <el-switch v-model="configModal.ativo" active-color="#13ce66"></el-switch>
                </el-form-item>

            </el-form>
            <template #modal-footer="{ hide }">
                <div class="float-right">
                    <el-button size="small" @click="hide()">Fechar</el-button>
                    <el-button size="small" type="primary" @click="salvarConfig" v-loading="formloading">Salvar</el-button> 
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>

const model = () => {
    return {
        _id: '',
        dataLimite: '',
        ativo: false
    }
}

export default {
    name: 'configuracoes-sincronizacao',
    data() {
        return {
            formloading: false,
            isEdit: false,
            configModal: model(),
            rules: {
				configSincronizacao: {
					dataLimite: [{ required: true, message: 'Limite de competência é um campo obrigatório!', trigger: 'blur' }]}
			}
        }
    },
    methods: {
        async getConfigSincronizacao() {
            this.formloading = false

            let response = await this.axios.get(this.$urls.OBTER_CONFIG_SINCRONIZACAO)

            if (response.status !== 200) {
                return;
            }

            this.configModal = response.data;

            if (this.configModal._id == null) {
                this.isEdit = false;
            }
            else {
                this.isEdit = true;
            }

            this.formloading = false
        },
        fecharModal(){
            this.$refs.configSincronizacaoModal.hide()
        },
        async salvarConfigRequest() {
            this.formloading = true

            const response = this.isEdit
            ?  await this.axios.put(this.$urls.EDITAR_CONFIG_SINCRONIZACAO, this.configModal)
            :  await this.axios.post(this.$urls.CRIAR_CONFIG_SINCRONIZACAO, this.configModal)
        
            if (response.status !== 200) {
                return;
            }

            this.formloading = false

            this.fecharModal()

            this.getConfigSincronizacao()

            this.$notify({
                type: "success",
                title: 'Configuração de sincronização salva',
                message: ''
            });
        },
        salvarConfig() {
            const ctx = this;
            ctx.$confirm('Essa ação impacta na Sincronização', 'Atenção!!!', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {

                ctx.$refs['formConfigSincronizacao'].validate((valid) => {
                    if (!valid) {
                        ctx.$notify.error({
                            title: 'Validação',
                            message: `Por favor, adicione um limite de competência`,
                            position:'top-left'
                        });
                        return;
                    }

                    ctx.salvarConfigRequest();
                });   
                
            }).catch(() => {
                ctx.$notify({
                    type: "success",
                    title: 'Operação cancelada',
                    message: ''
                });         
            });
        }
    },
    mounted() {
        this.getConfigSincronizacao();
    }
}
</script>

<style lang="scss">
.img-aviso-config {
    width: 130px;
}
</style>